import {Civilites} from "../datas/consts";
import {ClientFormComponent} from "../common-parts/forms/client-form/client-form.component";
import {SelectClientComponent} from "../common-parts/selects/select-client/select-client.component";
import {GroupeModel} from "./groupe.model";
import {SelectRegimeComponent} from "../common-parts/selects/select-regime/select-regime.component";

export class RegimeModel {
  public id: number;
  public nom: string;
  public description: string;
  public createdAt: Date;
  public updatedAt: Date;

  constructor(maxDepth = 1) {
    maxDepth--;
    this.id = 0;
    this.nom = '';
    this.description = '';
    this.createdAt = new Date();
    this.updatedAt = new Date();
  }

  getDefaultTitle() {
    return 'Regime';
  }

  getDefaultPrefixTitle() {
    return 'un';
  }

  getIndex() {
    return 'id';
  }

  getDefaultLibelleFields() {
    return ['nom'];
  }

  getDefaultSelectComponent() {
    return SelectRegimeComponent;
  }

  getDefaultFormComponent() {
    return null;
  }

  getEntityUrl() {
    return 'regime';
  }
}
